export default __webpack_public_path__ + "static/media/ic_learn.acaf90ef.svg";